import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private currentModal = signal<string | null>(null);

  open(modalId: string): void {
    this.currentModal.set(modalId);
  }

  close(): void {
    this.currentModal.set(null);
  }

  isOpen(modalId: string): boolean {
    return this.currentModal() === modalId;
  }

  getCurrentModal() {
    return this.currentModal.asReadonly();
  }
}
